import { render } from "./dataTitle.vue?vue&type=template&id=6cfe31d0"
import script from "./dataTitle.vue?vue&type=script&lang=js"
export * from "./dataTitle.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__